{
    "Profile_Dwellings_LossPayee.lossPayee": "FR: Loss Payee",
    "Profile_Dwellings_LossPayee.lossPayeeDetails": "FR: Loss Payee Details",
    "Profile_Dwellings_LossPayee.name": "FR: Name"
}
